/**
 * Quick Navigation Blocks
 *
 *
 * @class rlQuickNav
 * @memberOf jQuery.fn
 */

(function($) {
    $.fn.rlQuickNav = function() {
        //store quick nav blocks in array
        var quickNavIdNames = [];

        //loop over blocks set unique ID and push to array
        $('.quicknavigationcontainerblock').each(function(key) {

            var quickNavIdName = 'quickNavContainer' + key;
                quickNavSelect = 'quickNavMob' + key;

            $(this).children('.row').attr('id', quickNavIdName);
            $(this).find('select').attr('name', quickNavSelect).attr('id', quickNavSelect);

            quickNavIdNames.push(quickNavIdName);

        });
        //run function over each block individually
        quickNavIdNames.forEach(function(quickNavId) {
            /* Adds side menu based on H2 anchors on the page */
            $('#' + quickNavId + ' .quicknav-container h2.anchor-link').each(function(i) {
                var headingText = $(this).text();
                var ancnum = headingText + (i + 1);

                $(this).attr('id', ancnum.replace(/[^A-Z0-9]+/ig, "_"));

                $('#' + quickNavId + ' .quicknav-menu ul').append('<li class="nav-item"><a class="nav-link" href="#' + ancnum.replace(/[^A-Z0-9]+/ig, "_") + '"><span>' + headingText + '</span></a></li>');

                $('#' + quickNavId + ' .quickNav-mobile .custom-dropdown-select .custom-options').append('<a data-toggle="list" href="#' + ancnum.replace(/[^A-Z0-9]+/ig, "_") + '" role="tab"><span class="custom-option">' + headingText + '</span></a>');
                $('#' + quickNavId + ' .quickNav-mobile select').append('<option value="#' + ancnum.replace(/[^A-Z0-9]+/ig, "_") + '">' + headingText + '</option>');

            });
            //add <optgroup> to stop mobile device ui truncating option text
            $('#' + quickNavId + ' .quickNav-mobile select').append('<optgroup></optgroup>');

            //only do scroll stuff if there is a quick nav block on page
            if ($('.quicknavigationcontainerblock').length) {

                var scrolled;

                $(window).scroll(function () {
                    scrolled = true;
                    clearTimeout($.data(this, 'scrollTimer'));
                    $.data(this, 'scrollTimer', setTimeout(function () {

                        if (scrolled) {
                            itScrolled();
                            scrolled = false;
                        }
                        
                    }, 200));
                });

                $('.quicknav-menu ul li:first-child a').addClass('active-scroll');

            } 

            // check when scrolled and apply custom 'scroll spy' stuff to menu
            function itScrolled() {
                var scrollDistance = $(window).scrollTop();
                // Assign active class to nav links while scolling
                $('#' + quickNavId + ' .quicknav-item').each(function(i) {
                    if ($(this).offset().top - 200 <= scrollDistance || $(this).offset().top == 0) {
                        //desktop menu active states
                        $('#' + quickNavId + ' .quicknav-menu a.active-scroll').removeClass('active-scroll');
                        $('#' + quickNavId + ' .quicknav-menu a').eq(i).addClass('active-scroll');
                        //mobile menu active states
                        var h2Href = $('#' + quickNavId + ' .quicknav-menu a.active-scroll').attr('href');
                        $('#' + quickNavId + ' select').val(h2Href);
                    }
                });

                $('#' + quickNavId).each(function() {
                    var position = $(this).position();
                    var QuickNavMob = $('#' + quickNavId + ' .quickNav-mobile.sticky');
                    var QuickNavDesktop = $(this).find('.quickNav-desktop');

                    //check if header nav is down in squeezed state and move quick nav down to clear it
                    if ($('#header').hasClass('nav-squeeze') && $('#header').hasClass('nav-down') && QuickNavMob.offset().top - 80 > position.top) {
                        QuickNavMob.css('top', '80px');
                    } else if (QuickNavMob.offset().top == position.top || QuickNavMob.offset().top - 20 == position.top) {
                        QuickNavMob.css('top', '0px');
                    } else if (QuickNavMob.offset().top - 80 > position.top || QuickNavMob.offset().top - 20 > position.top) {
                        QuickNavMob.css('top', '20px');
                    }

                    //position sticky js polyfills

                    //mobile
                    if (QuickNavMob.css('position') === 'absolute') {
                        QuickNavMob.addClass('topposition');
                    }
                    else {
                        QuickNavMob.removeClass('topposition');
                    }

                    //desktop
                    if (QuickNavDesktop.css('position') === 'fixed') {
                        QuickNavDesktop.addClass('topposition');
                    }
                    else {
                        QuickNavDesktop.removeClass('topposition');
                    }
                });
            };

            //set default to first elements value
            $('#' + quickNavId + ' select option:first-of-type').attr('selected', 'selected');
        });

        //polyfill for position sticky for IE (and when overflow is applied to parent)
        Stickyfill.forceSticky();
        Stickyfill.add(document.querySelectorAll('[data-sticky]'));


        //////////
        //Events//
        //////////

        $(".quickNav-desktop a").on('click', function (event) {
            event.preventDefault();
            SmoothScroll(this);
        });

        $(".quickNav-desktop a").on('keydown', function (event) {
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if (keycode == 32) { //spacebar
                event.preventDefault();
                SmoothScroll(this);
            }
        });

        $(".quickNav-mobile select").on('change', function () {
            SmoothScroll(this);
        });


        function SmoothScroll(el) {
            let attr = $(el).val(),
                headerSize = $('header').outerHeight(),
                selectSize = $(el).outerHeight(),
                spacer = 20;
            const docwindow = $(window);

            if ($(el).parents('div').hasClass('quickNav-desktop')) {
                attr = $(el).attr('href');
            }

            let headerHeight = 100;

            if (docwindow.width() <= 767.98) {
                headerHeight = headerSize + selectSize + spacer;
            }
            else if (docwindow.width() <= 991.98) {
                headerHeight = 110;
            }
            else if (docwindow.width() <= 1199.98) {
                headerHeight = 120;
            }
            else {
                headerHeight = 100;
            }

            $('html, body').stop().animate({
                'scrollTop': $(attr).offset().top - headerHeight
            }, 800, 'swing');
        }
    }
}(jQuery));
